import { PricingPlan } from '../types';

// Mock data para planos de preços
const mockPricingPlans: PricingPlan[] = [
  {
    id: 'monthly',
    name: 'Mensal',
    price: 'R$ 39,90',
    period: 'por mês',
    features: [
      'Análise ilimitada de notícias',
      'Notificações instantâneas',
      'Suporte por chat',
      'Acesso a 5 empresas',
      'Relatórios básicos'
    ]
  },
  {
    id: 'annual',
    name: 'Anual',
    price: 'R$ 399,00',
    originalPrice: 'R$ 478,80',
    period: 'por ano',
    features: [
      '12 meses por 10x R$ 39,90',
      'Acesso antecipado a novas funcionalidades',
      'Suporte premium',
      'Acesso a empresas ilimitadas',
      'Relatórios avançados',
      'Análise de tendências',
      'Alertas personalizados'
    ],
    isPopular: true,
    isAnnual: true
  }
];

export const pricingService = {
  // Buscar todos os planos
  getAllPlans: async (): Promise<PricingPlan[]> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [...mockPricingPlans];
  },

  // Buscar plano por ID
  getPlanById: async (planId: string): Promise<PricingPlan | null> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockPricingPlans.find(plan => plan.id === planId) || null;
  },

  // Buscar plano mensal
  getMonthlyPlan: async (): Promise<PricingPlan | null> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockPricingPlans.find(plan => plan.id === 'monthly') || null;
  },

  // Buscar plano anual
  getAnnualPlan: async (): Promise<PricingPlan | null> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockPricingPlans.find(plan => plan.id === 'annual') || null;
  },

  // Calcular desconto do plano anual
  calculateAnnualDiscount: async (): Promise<number> => {
    await new Promise(resolve => setTimeout(resolve, 100));
    const monthlyPlan = mockPricingPlans.find(plan => plan.id === 'monthly');
    const annualPlan = mockPricingPlans.find(plan => plan.id === 'annual');
    
    if (monthlyPlan && annualPlan) {
      const monthlyPrice = parseFloat(monthlyPlan.price.replace('R$ ', '').replace(',', '.'));
      const annualPrice = parseFloat(annualPlan.price.replace('R$ ', '').replace(',', '.'));
      const monthlyYearly = monthlyPrice * 12;
      const discount = ((monthlyYearly - annualPrice) / monthlyYearly) * 100;
      return Math.round(discount);
    }
    
    return 0;
  }
};

